<script>
export default {
  name: "max-budget-detail",
  props: ["item"],
  data() {
    return {
      form: {
        max_campaign_budget: null,
        max_monthly_budget: null
      }
    };
  },
  computed: {
    max_campaign_budget_id() {
      return `max_campaign_budget_${this.item.id}`;
    },
    max_monthly_budget_id() {
      return `max_monthly_budget_${this.item.id}`;
    }
  },
  methods: {
    handleMaxCampaignBudget() {
      this.form.max_monthly_budget = null;
    },
    handleMaxMonthlyBudget() {
      this.form.max_campaign_budget = null;
    }
  }
};
</script>

<template>
  <tr>
    <td>{{ item.name }}</td>
    <td>
      <b-form-input
        :id="max_campaign_budget_id"
        v-model="form.max_campaign_budget"
        type="number"
        required
        placeholder="$0.00"
        @change="handleMaxCampaignBudget"
        @keyup="handleMaxCampaignBudget"
      ></b-form-input>
    </td>
    <td>
      <b-form-input
        :id="max_monthly_budget_id"
        v-model="form.max_monthly_budget"
        type="number"
        required
        placeholder="$0.00"
        @change="handleMaxMonthlyBudget"
        @keyup="handleMaxMonthlyBudget"
      ></b-form-input>
    </td>
  </tr>
</template>
